const trackFSEvent = (name, properties = {}) => {
	if (window.FS) {
		window.FS('trackEvent', {
			name: name,
			properties: properties
		});

		if (window.location.hostname.includes('127.0.0.1')) {
			console.log('Track FullStory event', name, properties);
		}
	}
}

window.trackFSEvent = trackFSEvent;

// Currency format
theme.Currency = (function() {
    var moneyFormat = theme.moneyFormat; // eslint-disable-line camelcase
  
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;
  
      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';
  
        if (isNaN(number) || number === null) {
          return 0;
        }
  
        number = (number / 100.0).toFixed(precision);
  
        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';
  
        return dollarsAmount + centsAmount;
      }
  
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
  
      return formatString.replace(placeholderRegex, value);
    }
  
    return {
      formatMoney: formatMoney
    };
  })();

// Add to cart
const addToCartGlobal = async (handle, variantId, quantity, isBundle, preorderMonth = undefined, properties = undefined) => {
    return addAllToCart([{handle, variantId, quantity, isBundle, preorderMonth, properties}]);
}

const addAllToCart = async (products) => {
    const productList = products;

    let promises = productList.map(product => buildCartItems(product));
    let cartItemsArray = await Promise.all(promises);
    let cartItems = cartItemsArray.flat(1);

    const add = async () => {
        let resp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({items: cartItems})
        });

        return resp;
    }

    let resp = await add();

    if (!resp.ok) {
        let json = await resp.json();
        return json.description;
    }

    fetch('https://cart-count.bedthreads.workers.dev/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ handles: productList.map(p => p.handle) }),
        mode: 'no-cors'
    });

    fetch('/cart.js').then(resp => resp.json()).then(json => {
        const successful = cartItems.some(item => json.items.some(cartItem => cartItem.variant_id == item.id || cartItem.properties['_BundleId'] == item.properties['_BundleId']));
        trackFSEvent('Add To Cart Attempt', { successful });
    })
}

// Announce a cart update to screen readers via the #cart-live-region status element (see theme.liquid).
// Clearing first then setting on the next frame guarantees the same/similar text is re-announced.
window.announceCartUpdate = (message) => {
    const liveRegion = document.getElementById('cart-live-region');
    if (!liveRegion || !message) return;

    liveRegion.textContent = '';
    requestAnimationFrame(() => {
        liveRegion.textContent = message;
    });
}

const buildCartItems = async ({handle, variantId, quantity = 1, isBundle = false, preorderMonth, sellingPlan, properties = {}}) => {
    const items = [];

    if (isBundle) {
        // Add unique property to each bundle to prevent showing as one line in cart
        const bundleId = Date.now();

        for (let i = 0; i < quantity; i++) {
            items.push({
                id: variantId,
                quantity: 1,
                selling_plan: sellingPlan ? sellingPlan : undefined,
                properties: { 
                    '_LineId': `${bundleId}-${i}`,
                    'PreOrder': preorderMonth ? `${preorderMonth} delivery` : undefined,
                    ...properties
                }
            });
        }
    }
    else {
        items.push({
            id: variantId,
            quantity: quantity,
            selling_plan: sellingPlan ? sellingPlan : undefined,
            properties: { 
                'PreOrder': preorderMonth ? `${preorderMonth} delivery` : undefined,
                ...properties
            }
        });
    }

    return items
}

window.theme.buyNow = async (items) => {
    const mutation = /* GraphQL */ `mutation checkoutCreate($input: CheckoutCreateInput!) {
        checkoutCreate(input: $input) {
            checkout {
                webUrl
            }
        }
    }`

    let input = {
        lineItems: []
    };
    
    for (let item of items) {
        input.lineItems.unshift({
            variantId: `gid://shopify/ProductVariant/${item.id}`,
            quantity: item.quantity,
            customAttributes: Object.entries(item.properties ? item.properties : []).map(([key, value]) => ({key: key, value: value.toString()}))
        })
    }

    let storefrontToken = theme.storefrontToken;
    let resp = await fetch('/api/2023-01/graphql.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': storefrontToken
        },
        body: JSON.stringify({query: mutation, variables: {input: input}})
    });

    let json = await resp.json();
    window.location.href = json.data.checkoutCreate.checkout.webUrl;
}

// Event tracking
const eventTrackingDefs = {
    // Product pages
    '.breadcrumb a': 'Breadcrumb nav',
    'a[href="#reviews"]': 'PDP clickable X reviews',
    '.size_guide_modal, .size_guide_modal *': 'Size guide open',
    '.size-guide-container .close-overlay': 'Size guide ignore',
    '.size-guide-container .close-icon': 'Size guide close',
    'discount-pill': 'Discount code copy',
    // <details> toggles `open` as the click's default action, after the event
    // has finished bubbling — so here `open` is still the pre-click state.
    '.product-accordion:not([open]) > .product-accordion__summary': {
        funnelLocation: target => `${target.innerText.trim()} section open`
    },
    '.product-accordion[open] > .product-accordion__summary': {
        funnelLocation: target => `${target.innerText.trim()} section close`
    },
    '.product-details__read-less, .product-details__read-less *': 'Details section - read less',
    '.product-details__read-more, .product-details__read-more *': 'Details section - read more',
    '.product__mixed-disclaimer a': 'Special size hyperlink',
    '.yotpo-points-widget__login a[href="/account/login"]': 'PDP login loyalty',
    '.yotpo-points-widget__login a[href="/account/register"]': 'PDP signup loyalty',

    // Images
    '.product__media *': 'PDP image click',
    '.pswp__img': 'PDP image zoom',
    '.pwsp__bg, .pswp__button--close, .pswp__item': 'PDP image close',

    '#AddToCart-product-template': 'Add to Cart',
    // The label span swallows most of the clicks, and this handler only matches
    // on e.target — no closest() — so the descendant selector has to be listed too.
    '.sticky-atc__button, .sticky-atc__button *': 'Add to Cart - Sticky',
    '.product-swatch__item *': 'Swatch change',

    '.byob-block-container *': 'BYOB block',

    // Wishlist
    '.site-header wishlist-icon, .site-header wishlist-icon *': 'Wishlist / Header icon',
    '.icon-account-mobile[href="/pages/wishlist"]': 'Wishlist / Mobile nav link',
    'wishlist-add-button:not(.product__images > wishlist-add-button):not(.wishlist-add-button--has-label)': 'Wishlist / Add button (product card)',
    '.product__images wishlist-add-button': 'Wishlist / Add button (PDP product image)',
    '.product-3d-bundle .wishlist-add-button': 'Wishlist / Add button (BYOB)',
    'wishlist-add-button.wishlist-add-button--has-label, wishlist-add-button.wishlist-add-button--has-label *': 'Wishlist / Add button (PDP below ATC button)',
    '.wishlist-item__remove, .wishlist-item__remove *': 'Wishlist / Remove item',
    'wishlist-item button[name="add"], wishlist-item button[name="add"] *': 'Wishlist / Add item to cart',
    'wishlist-item-byob button[name="add"], wishlist-item button[name="add"] *': 'Wishlist / Add item to cart (BYOB)',
    'wishlist-item-byob .wishlist-item__edit': 'Wishlist / Edit bundle (BYOB)',
    'wishlist-item button[name="size"], wishlist-item button[name="size"] *': 'Wishlist / Show size selector',
    'wishlist-item .size-selector__size-guide': 'Wishlist / Show size guide',
    'wishlist-item .size-selector__buttons button': 'Wishlist / Select size',
    'wishlist-item .wishlist-item__qty-decrease, wishlist-item .wishlist-item__qty-decrease *': 'Wishlist / Decrease quantity',
    'wishlist-item .wishlist-item__qty-increase, wishlist-item .wishlist-item__qty-increase *': 'Wishlist / Increase quantity',
    'wishlist-item-byob .wishlist-item__qty-decrease, wishlist-item-byob .wishlist-item__qty-decrease *': 'Wishlist / Decrease quantity (BYOB)',
    'wishlist-item-byob .wishlist-item__qty-increase, wishlist-item-byob .wishlist-item__qty-increase * ': 'Wishlist / Increase quantity (BYOB)',
    'wishlist-contents button[name="clear"]': 'Wishlist / Clear entire wishlist',
    'wishlist-contents button[name="add-all"]': 'Wishlist / Add all items to cart button',
    // By the time event propagates to top, button name has been toggled
    'wishlist-item button[name="hide"], wishlist-item-byob button[name="hide"]': 'Wishlist / View bundle items',
    'wishlist-item button[name="show"], wishlist-item-byob button[name="show"]': 'Wishlist / Hide bundle items',
    '.wishlist__subtitle a': 'Wishlist / Log in link',
    'wishlist-undo-toast button[name="undo"]': 'Wishlist / Undo button'
}

window.pushEvent = (eventData) => {
    if (typeof eventData === 'string') eventData = {funnelLocation: eventData};
    //console.log('Fire event', eventData)

    const payload = {
        event: 'uxTracking', 
        ...eventData
    };

    window.setTimeout(() => {
        if (typeof window.requestIdleCallback === 'function') {
            window.requestIdleCallback(() => window.dataLayer.push(payload), { timeout: 2000 });
        }
        else window.dataLayer.push(payload);
    }, 500);
}

document.addEventListener('click', e => {
    if (!e.isTrusted) return;
    for (let selector in eventTrackingDefs) {
        if (e.target.matches(selector)) {
            let def = eventTrackingDefs[selector];

            if (typeof def === 'object') {
                def = Object.fromEntries(Object.entries(def));
                
                for (let [prop, val] of Object.entries(def)) {
                    if (typeof val === 'function') def[prop] = val(e.target);
                }
            }

            window.pushEvent(def);
        }
    }
});

// Flex section scroll tracking

for (const section of document.querySelectorAll('.flex-section')) {
	const cards = section.querySelector('.flex-section__cards ul');
	if (!cards) continue;

	const title = section.querySelector('.flex-section__text h2');
	const titleText = title && title.innerText.trim();

	cards.addEventListener('scroll', e => {
		window.trackFSEvent('Flex Section Scroll', { section: titleText });
	}, { once: true, passive: true});
}

// Page links scroll tracking

for (const pageLinks of document.querySelectorAll('.page-links ul')) {
	pageLinks.addEventListener('scroll', e => {
		window.trackFSEvent('Page Links Scroll');
	}, { once: true, passive: true});
}



class BISForm extends HTMLElement {
    constructor() {
        super();

        let bisButton = this.querySelector('.bis-form__input-button');
        if (bisButton) {
            let bisInput = this.querySelector('.bis-form__input-email');
            let errorText = this.querySelector('.bis-form__input-error');

            bisButton.addEventListener('click', async e => {
                if (bisInput.validity.valid) {
                    errorText.innerHTML = '';

                    this.classList.add('bis-loading');
                    bisButton.classList.add('show-loading');
                    bisButton.disabled = true;
                    bisInput.disabled = true;

                    await BIS.create(bisInput.value, this.getAttribute('variant'), this.getAttribute('product'));

                    this.classList.remove('bis-loading');
                    bisButton.classList.remove('show-loading');
                    this.classList.add('bis-success');
                    bisButton.disabled = false;
                    bisInput.disabled = false;  
                    setTimeout(() => this.classList.remove('bis-success'), 5000);

                    this.dispatchEvent(new CustomEvent('bissuccess', { bubbles: true }));
                }
                else errorText.innerHTML = bisInput.validationMessage;
            });
        }
    }
}

customElements.define('bis-form', BISForm);

class DynamicPrice extends HTMLElement {
    static get observedAttributes() {
        return ['data-handle', 'handle'];
    }

    connectedCallback() {
        this.innerHTML = '&nbsp;';
        this.dataset.loading = "true";

        if (this.getAttribute('lazy') != null) {
            const observer = new IntersectionObserver(entries => {
                if (entries.some(e => e.isIntersecting)) {
                    observer.disconnect();
                    this.update();
                }
            }, { rootMargin: '0px 50% 50% 0px' });
            observer.observe(this);
        }
        else this.update();
    }

    attributeChangedCallback() {
        this.innerHTML = '&nbsp;';
        this.dataset.loading = "true";

        if (this.isConnected && (this.getAttribute('lazy') == null)) {
            setTimeout(() => this.update(), 100);
        }
    }

    async update() {
        this.handle = this.dataset.handle ?? this.getAttribute('handle');

        if (this.handle.includes("result.handle")) return;

        const priceListElem = document.getElementById('priceList');
        const priceList = priceListElem ? JSON.parse(priceListElem.innerHTML) : null;
        let priceData = null

        if (priceList && priceList[this.handle]) priceData = priceList[this.handle];
        else {
            const resp = await fetch(`/products/${this.handle}?view=price-json`);
            if (resp.ok) priceData = await resp.json();
        }

        if (priceData) {
            this.innerHTML = priceData.price;
            this.dataset.loading = "false";

            if (theme.automaticDiscount && theme.discountAmount && priceData.autoDiscountEligible) {
                const card = this.closest('.card, .product-card');
                if (card) {
                    const tag = card.querySelector('.tag-item');
                    if (tag && tag.innerText.includes('%')) {
                        // Extract number from tag
                        const discount = parseInt(tag.innerText.replace(/[^0-9]+/, ''));
                        const multiplier = 1 - (discount / 100);
                        const discountMultiplier = 1 - (theme.discountAmount / 100);
                        const total = multiplier * discountMultiplier;
                        const newDiscount = Math.ceil(100 - (total * 100));
                        tag.innerText = tag.innerText.replace(discount.toString(), newDiscount.toString());
                    }
                }
            }
        }
    }
}

customElements.define('dynamic-price', DynamicPrice);


class YouTubeOverlay extends HTMLElement {
	async connectedCallback() {
		const youtubeId = this.getAttribute('id');
		let youtubePlayer = null;
		
		const iframeContainer = document.createElement('div');
		iframeContainer.id = 'youtube-overlay-iframe';
		this.appendChild(iframeContainer);

		var tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		await new Promise(resolve => {
			window.onYouTubeIframeAPIReady = resolve;
		});

		await new Promise(resolve => {
			const width = Math.min(window.innerWidth, 1440);
			youtubePlayer = new YT.Player('youtube-overlay-iframe', {
				height: (width * 0.5625).toString(),
				width: width.toString(),
				videoId: youtubeId,
				playerVars: {
					'playsinline': 1,
					'rel': 0,
					'color': 'white',
                    'autoplay': 0
				},
				events: {
					'onReady': resolve,
					'onStateChange': event => {
						if (event.data == YT.PlayerState.UNSTARTED || event.data == YT.PlayerState.BUFFERING) this.classList.add('youtube-loading');
						if (event.data == YT.PlayerState.PLAYING) {
							this.classList.add('youtube-loaded');
							this.classList.remove('youtube-loading');
						}
					}
				}
			});
		});

		this.classList.add('youtube-ready');
        this.classList.add('youtube-loaded');

		this.addEventListener('click', e => {
			youtubePlayer.playVideo();
		});
	}
}

customElements.define('youtube-overlay', YouTubeOverlay);

class LazyloadVideo extends HTMLElement {
	constructor() {
		super();

		const observer = new IntersectionObserver(entries => {
			if (entries.some(e => e.isIntersecting)) {
				observer.disconnect();
				this.querySelector('video').play();
			}
		});
		observer.observe(this);
	}
}

customElements.define('lazyload-video', LazyloadVideo);

class VideoBlock extends HTMLElement {
    constructor() {
		super();

        this.playing = false;
        this.carousel = this.closest('carousel-v2');

        const autoplay = this.getAttribute('autoplay');

        if (autoplay === 'hover') {
            this.addEventListener('mouseenter', e => this.play());
            this.addEventListener('mouseleave', e => this.pause());
        }
        else if (this.carousel) {
            this.initCarouselBehavior();
        }
        else {
            this.initDefaultBehavior();
        }

        const muteToggle = this.querySelector('.video-block__mute-toggle');

        if (muteToggle) {
            muteToggle.addEventListener('click', e => {
                if (this.hasAttribute('muted')) {
                    if (this.carousel) this.carousel.querySelectorAll('video-block').forEach(vb => vb.unmute());
                    else this.unmute();
                } else {
                    if (this.carousel) this.carousel.querySelectorAll('video-block').forEach(vb => vb.mute());
                    else this.mute();
                }
            }); 

            const observer = new IntersectionObserver(entries => {
                if (!this.hasAttribute('muted')) {
                    this.querySelectorAll('video').forEach(video => {
                        video.muted = entries.some(e => !e.isIntersecting);
                    });
                }
            }, { rootMargin: '-20% -0% -20% 0%' });
            observer.observe(this);
        }
	}

    mute() {
        this.setAttribute('muted', '');
        this.querySelectorAll('video').forEach(video => {
            video.muted = true;
        });
    }

    unmute() {
        this.removeAttribute('muted');
        this.querySelectorAll('video').forEach(video => {
            video.muted = false;
        });
    }


    initDefaultBehavior() {
        const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) {
                if (!this.playing) this.play();
            }
            else {
                this.pause();
            }
        }, { rootMargin: '0px 0px 0px 0px' });
        observer.observe(this);
    }

    initCarouselBehavior() {
        const isMobile = window.innerWidth < 992;

        if (isMobile) {
            // Mobile: play when video intersects the root margin
            const observer = new IntersectionObserver(entries => {
                if (entries.some(e => e.isIntersecting)) {
                    if (!this.playing) this.play();
                }
                else {
                    this.pause();
                }
            }, { rootMargin: '0% -20% 0% -20%' });
            observer.observe(this);
        }
        else {
            // Desktop: first video plays on intersection, others play on click
            const videosInCarousel = this.carousel.querySelectorAll('video-block');
            const index = Array.from(videosInCarousel).indexOf(this);

            if (index === 0) {
                // First video plays on viewport intersection
                const observer = new IntersectionObserver(entries => {
                    if (entries.some(e => e.isIntersecting)) {
                        observer.disconnect();
                        this.play();
                    }
                }, { rootMargin: '0px 0px 0px 0px' });
                observer.observe(this);
            }

            // Other videos play on click and pause siblings
            this.addEventListener('click', () => {
                // Pause all other videos in the carousel
                videosInCarousel.forEach(videoBlock => {
                    if (videoBlock !== this) videoBlock.pause();
                });

                this.carousel.scrollToIndex(index, { centre: true });
                this.play();
            });
        }
    }

    play() {
        const video = this.querySelector(window.innerWidth < 992 ? 'video.video-block__mobile-video' : 'video.video-block__desktop-video');
        if (!video) return;

        this.playing = true;

        video.addEventListener('playing', () => {
            video.style.visibility = 'visible';
        }, { once: true });

        video.style.display = '';
        video.play().catch(() => {
            // Autoplay blocked (e.g. iOS Low Power Mode) or interrupted — fall back to the
            // poster and let the next intersection retry, unless a later play() took over
            if (!video.paused) return;
            this.playing = false;
            video.style.display = 'none';
        });
    }

    pause() {
        const video = this.querySelector(window.innerWidth < 992 ? 'video.video-block__mobile-video' : 'video.video-block__desktop-video');
        if (!video) return;

        this.playing = false;
        video.style.display = 'none';
        video.style.visibility = 'hidden';
        video.pause();
        video.currentTime = 0; 
    }
}

customElements.define('video-block', VideoBlock);

class LazyloadContent extends HTMLElement {
    constructor() {
		super();

        if (this.hasAttribute('eager')) this.load();
        else {
            const margin = this.getAttribute('margin') || '50%';

            const observer = new IntersectionObserver(entries => {
                if (entries.some(e => e.isIntersecting)) {
                    observer.disconnect();
                    this.load();
                }
            }, { rootMargin: `0px 0px ${margin} 0px` });
            observer.observe(this);
        }
	}

    async load() {
        let content = null;

        if (this.hasAttribute('content')) content = this.getAttribute('content');
        else if (this.hasAttribute('url')) {
            const resp = await fetch(this.getAttribute('url'));
            if (resp.ok) content = await resp.text();
        }

        if (content) {
            const doc = new DOMParser().parseFromString(content, 'text/html');
            const nodes = [...doc.body.childNodes, ...doc.head.childNodes];
            const scripts = doc.querySelectorAll('script');

            this.replaceWith(...nodes);

            for (const script of scripts) {
                const newScript = document.createElement('script');
                [...script.attributes].forEach( attr => { newScript.setAttribute(attr.nodeName ,attr.nodeValue) });
                newScript.innerHTML = script.innerHTML;
                script.replaceWith(newScript);
                if (newScript.src.includes('instagram')) window.instgrm.Embeds.process();
            }
        }
    }
}

customElements.define('lazyload-content', LazyloadContent);

class CardSlideshow extends HTMLElement {
    constructor() {
        super();

        this.index = 0;
        this.handle = null;
        this.started = false;
        this.promise = null;

        this.addEventListener('mouseenter', e => {
            if (window.innerWidth < 992) return;
            if (this.started) return;
            this.handle = setTimeout(() => this.start(), 500);
        });

        this.addEventListener('mouseleave', e => this.cancel());

        this.addEventListener('scroll', e => {
            const scrollPercentage = (this.scrollLeft / (this.scrollWidth - this.clientWidth)) * 100;
            this.style.setProperty('--scroll', `${scrollPercentage}%`);
            this.setAttribute('interacted', '');
        });

        const updateSlideCount = () => this.style.setProperty('--slides', this.children.length);
        const mutObserver = new MutationObserver(updateSlideCount);
        mutObserver.observe(this, { childList: true });
        updateSlideCount();

        this.classList.add('init');
    }

    async start() {
        this.setAttribute('interacted', '');
        if (this.started) return;
        this.started = true;

        const callback = async () => {
            this.promise = this.next();
            await this.promise;
            if (!this.started) return;
            if (this.handle) clearTimeout(this.handle);
            this.handle = setTimeout(callback, 1500);
        }

        callback();
    }

    async cancel() {
        if (this.promise) await this.promise;
        await this.setIndex(0);
        clearTimeout(this.handle);
        this.started = false;
        this.handle = null;
    }

    async next() {
        let index = this.index >= this.children.length - 1 ? 0 : this.index + 1;
        await this.setIndex(index);
    }

    async setIndex(index) {
        const current = this.children[this.index];
        this.index = index;
        const picture = this.children[index];

        if (picture != current) {
            const image = picture.querySelector('img');
            image.setAttribute('loading', 'eager');
            await image.decode();

            current.style.opacity = 0;
            picture.style.display = 'block';
            picture.style.opacity = 1;
        }
    }
}

customElements.define('card-slideshow', CardSlideshow);


/* Card swatch selector */

class CardSwatchSelector extends HTMLElement {
    static cache = new Map();

    async connectedCallback() {
        if (this.initialized) return;

        if (this.hasAttribute('lazyload')) {
            this.observer = new IntersectionObserver(async entries => {
                if (entries.some(e => e.isIntersecting)) {
                    this.load();
                }
            }, { rootMargin: '0px 0px 50% 0px' });

            this.observer.observe(this);
        }
        else this.init();
    }

    // Returns the in-flight load when called again, so callers can wait for the swatches to exist
    load() {
        if (!this.observer) return this.loading;
        this.observer.disconnect();
        this.observer = null;

        this.loading = this.fetchSwatches();
        return this.loading;
    }

    async fetchSwatches() {
        const handle = this.getAttribute('handle');

        const cached = CardSwatchSelector.cache.get(handle);
        if (cached) this.innerHTML = cached;
        else {
            const resp = await fetch(`/products/${handle}/${this.hasAttribute('fabric') ? this.getAttribute('fabric') : ''}?view=swatch-selector`);
            const html = await resp.text();
            this.innerHTML = html;
            CardSwatchSelector.cache.set(handle, html);
        }

        this.classList.remove('card-swatch-selector-placeholder');
        this.init();
    }
    

    init() {
        this.initialized = true;

        this.addEventListener('mouseleave', () => {
            if (!window.matchMedia('(hover: hover)').matches) return;
            const selected = this.querySelector('card-swatch[active]');
            if (selected) selected.select();
        });

        this.addEventListener('mouseenter', () => {
            // Keep details size consistent when swatch is selected
            const details = this.closest('.card__details');

            const observer = new ResizeObserver(entries => {
                for (const entry of entries) {
                    const minHeight = parseInt(window.getComputedStyle(details).minHeight);
                    if (Number.isNaN(minHeight) || entry.contentRect.height > minHeight) {
                        details.style.minHeight = `${entry.contentRect.height}px`;
                    }
                }
            });

            observer.observe(details);
        }, { once: true });
        

        // Apply colour filters
        const params = new URLSearchParams(window.location.search);
        const coloursAttribute = this.hasAttribute('colours') ? JSON.parse(this.getAttribute('colours')) : [];
        const colourFilters = [...params.getAll('filter.p.m.custom.colours'), ...coloursAttribute];
        
        if (colourFilters.length > 0) {
            for (const swatch of this.querySelectorAll('card-swatch')) {
                const colour = swatch.getAttribute('colour');
                if (colour && !colourFilters.includes(colour)) swatch.remove();
            }
        }

        // Apply type filter
        if (this.hasAttribute('type')) {
            for (const swatch of this.querySelectorAll('card-swatch')) {
                const type = swatch.getAttribute('type');
                if (type !== this.getAttribute('type')) swatch.remove();
            }
        }

        // Apply tag filter
        if (this.hasAttribute('tag')) {
            const tag = this.getAttribute('tag');
            for (const swatch of this.querySelectorAll('card-swatch')) {
                const tags = swatch.getAttribute('tags').split(',');
                if (!tags.includes(tag)) swatch.remove();
            }
        }

        // Set swatches
        const featuredSwatches = [...this.querySelectorAll('.card-swatch--featured')];
        featuredSwatches.sort((a, b) => parseInt(a.getAttribute('order')) - parseInt(b.getAttribute('order')));
        const otherSwatches = [...this.querySelectorAll('card-swatch:not(.card-swatch--featured)')];
        const swatches = [...featuredSwatches, ...otherSwatches];

        // Automatically hide overflowing swatches
        const expandButton = this.querySelector('.card-swatch-selector__expand');
        if (expandButton) {
            expandButton.addEventListener('click', e => {
                expandButton.remove();
                this.classList.toggle('card-swatch-selector--expanded');
            }, { once: true });
        }

        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                const maxSwatches = Math.floor((entry.contentRect.width) / 28);

                if (maxSwatches < swatches.length) {
                    const visibleSwatches =  Math.floor((entry.contentRect.width - 30) / 28); // Leave space for the expand button
                    swatches.forEach((swatch, index) => swatch.toggleAttribute('hidden', index >= visibleSwatches));
                    this.classList.add('card-swatch-selector--overflow');
                    this.remainingSwatches = swatches.length - visibleSwatches;

                    if (expandButton) expandButton.innerHTML = `+ ${this.remainingSwatches} <span class="visually-hidden">more colours</span>`;
                }
                else {
                    swatches.forEach(swatch => swatch.removeAttribute('hidden'));
                    this.classList.remove('card-swatch-selector--overflow');
                }
            }
        });

        resizeObserver.observe(this);
    }
}

customElements.define('card-swatch-selector', CardSwatchSelector);

class CardSwatch extends HTMLElement {
    static selected = new Set();
    static fsEventHandle = null;

    constructor() {
        super();

        this.content = new DOMParser().parseFromString(this.getAttribute('content'), 'text/html');
        this.cardChildren = [...this.content.querySelectorAll('.card > *:not(.card__details)')];
        this.cardDetailsChildren = [...this.content.querySelectorAll('.card__details > *')];

        this.addEventListener('click', () => {
            this.select(false, true);
        });

        this.addEventListener('keydown', e => {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                this.select(false, true);
            }
        });

        this.addEventListener('mouseenter', () => {
            if (!window.matchMedia('(hover: hover)').matches) return;
            const card = this.closest('.card');
            if (card.classList.contains('card--tooltip-open')) return;

            this.select(true, true);
        });

        this.handle = this.getAttribute('handle');

        if (CardSwatch.selected.has(this.handle)) this.select();
    }

    select(quick = false, trusted = false) {
        const card = this.closest('.card');
        const swatches = card.querySelectorAll('card-swatch');
        if (this.hasAttribute('colour')) card.style.setProperty('--colour', `"${this.getAttribute('colour').replace('Piped', '')}"`);

        if (!quick) {
            swatches.forEach(swatch => {
                swatch.removeAttribute('active');
                swatch.setAttribute('aria-pressed', 'false');
                CardSwatch.selected.delete(swatch.handle);
                if (swatch.timeoutHandle) {
                    clearTimeout(swatch.timeoutHandle);
                    delete swatch.timeoutHandle;
                }
            });

            this.setAttribute('active', '');
            this.setAttribute('aria-pressed', 'true');

            if (!window.matchMedia('(hover: hover)').matches && this.hasAttribute('colour')) {
                card.classList.add('card--show-colour');
                this.timeoutHandle = setTimeout(() => {
                    card.classList.remove('card--show-colour');
                }, 2000);
            }
        }

        const image = card.querySelector('picture.card__image');
        
        const newChildren = quick ? [...this.cardChildren].filter(elem => !elem.matches('quick-add-to-cart')) : this.cardChildren;
        card.querySelectorAll(':scope > *:not(.card__details)').forEach(child => child.remove());
        card.append(...newChildren);

        const details = card.querySelector('.card__details');
        details.querySelectorAll(':scope > *:not(card-swatch-selector)').forEach(child => child.remove());
        details.append(...this.cardDetailsChildren);

        if (image) {
            const imageWidth = image.dataset.width;
            const desktopImageWidth = image.dataset.desktopWidth;

            const newImage = card.querySelector('picture.card__image');
            if (newImage) {
                newImage.dataset.width = imageWidth;
                newImage.dataset.desktopWidth = desktopImageWidth;

                const mobileImage = newImage.querySelector('img');
                if (mobileImage) mobileImage.src = mobileImage.src.replace(/width=\d+/, `width=${imageWidth}`);

                const desktopImage =  newImage.querySelector('source[media="(min-width: 992px)"]');
                if (desktopImage) desktopImage.srcset = desktopImage.srcset.replace(/width=\d+/, `width=${desktopImageWidth}`);
            }
        }

        const typeTitle = this.closest('card-swatch-selector[product-type="true"]')
        if (typeTitle) {
            card.querySelector('.card__title').innerText = this.getAttribute('type');
        }

        if (trusted && 'trackFSEvent' in window && typeof window.trackFSEvent === 'function') {
            if (CardSwatch.fsEventHandle) clearTimeout(CardSwatch.fsEventHandle);

            CardSwatch.fsEventHandle = setTimeout(() => {
                if (quick && !this.matches(':hover')) return;

                window.trackFSEvent(`Card Swatch ${quick ? 'Hover' : 'Click'}`, {
                    colour: this.getAttribute('colour'),
                    type: this.getAttribute('type'),
                });
            }, 500);
        }
    }
}

customElements.define('card-swatch', CardSwatch);

class CardTooltip extends HTMLElement {
    connectedCallback() {
        const viewed = localStorage.getItem(`tooltip-viewed-${this.id}`);
        const week = 1000 * 60 * 60 * 24 * 7;

        if (true || !viewed || parseInt(viewed) < Date.now() - week || window.Shopify.designMode) {
            this.card = this.closest('.card');
            
            const observer = new MutationObserver(() => {
                if (this.card.querySelector('card-swatch')) {
                    this.open();
                    observer.disconnect();
                };
            });

            observer.observe(this.card, { childList: true, subtree: true });
        }
    }

    open() {
        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                if (entry.contentBoxSize) {
                    const swatches =  this.card.querySelectorAll('card-swatch:not([hidden])');

                    if (swatches.length > 0) {
                        const swatch = swatches[Math.max(0, swatches.length - 2)];
                        const swatchRect = swatch.getBoundingClientRect();
                        const cardRect = this.card.getBoundingClientRect();
                        const paddingRight = parseInt(window.getComputedStyle(this).paddingRight);

                        this.style.bottom = `${cardRect.bottom - swatchRect.top + 16}px`;
                        this.style.right = `${cardRect.right - swatchRect.right - paddingRight + 4}px`;
                    }      
                }
            }
        });

        observer.observe(this.card);

        this.style.display = 'flex';
        this.classList.add('card-tooltip--transition-in');
        setTimeout(() => this.classList.remove('card-tooltip--transition-in'), 300);
        this.card.classList.add('card--tooltip-open');

        // Automatically close the tooltip after 5 seconds or when the user interacts with the swatch card
        this.autoCloseTimeout = setTimeout(() => this.close(), 5000);
        this.card.addEventListener('click', () => this.close(), { once: true, capture: true });
    }

    close() {
        if (this.autoCloseTimeout) {
            clearTimeout(this.autoCloseTimeout);
            this.autoCloseTimeout = null;
        }

        this.classList.add('card-tooltip--transition-out');
        setTimeout(() => this.remove(), 200);
        localStorage.setItem(`tooltip-viewed-${this.id}`, Date.now());
        this.closest('.card').classList.remove('card--tooltip-open');
    }
}

customElements.define('card-tooltip', CardTooltip);

class TabButton extends HTMLElement {
    constructor() {
        super(); 

        this.addEventListener('click', e => {
            const panels = this.closest('.shopify-section').querySelectorAll(`tab-panel[tab="${this.tab}"]`);
            this.closest('.shopify-section').querySelectorAll(`tab-panel`).forEach(panel => panel.removeAttribute('active'));

            for (const panel of panels) {
                this.parentElement.querySelectorAll('tab-button').forEach(button => button.removeAttribute('active'));
                this.setAttribute('active', '');
                this.scrollIntoView({ behavior: e.isTrusted ? 'smooth' : 'auto', block: 'nearest', inline: 'center' });

                panel.setAttribute('active', '');

                //if (panel.getBoundingClientRect().top < 0) panel.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'nearest'});
            }
        });  
    }

    connectedCallback() {
        this.tab = this.getAttribute('tab');
        if (this.id && window.location.hash == `#${this.id}`) this.click();
    }
}

customElements.define('tab-button', TabButton);


class FreeGiftAddToCart extends HTMLElement {
    constructor() {
        super();

        this.querySelector('.free-gift__choose-button').addEventListener('click', e => {
            if (e.target.hasAttribute('disabled')) return;

            if (this.hasAttribute('variant-id')) {
                e.target.classList.add('show-loading');
                this.addToCart(this.getAttribute('variant-id'), this.getAttribute('preorder') || null);
            }
            else this.querySelector('.free-gift__sizes-modal').toggle();
        });

        const sizeButtons = [...this.querySelectorAll('.free-gift__size-button')];
        for (const sizeButton of sizeButtons) {
            sizeButton.addEventListener('click', () => {
                if (sizeButton.hasAttribute('disabled')) return;
                sizeButton.classList.add('show-loading');
                // Disable the other sizes so a second add can't fire while this one is in flight
                for (const other of sizeButtons) other.setAttribute('disabled', '');
                const variantId = sizeButton.dataset.variantId;
                this.addToCart(variantId, sizeButton.dataset.preorder);
            });
        }
    }

    async addToCart(variantId, preorderMonth = null) {
        this.classList.add('free-gift-atc--loading');

        const handle = this.getAttribute('handle');
        const cart = this.closest('cart-contents');
        const blockId = this.getAttribute('block-id');
        const blockType = this.getAttribute('block-type') || 'threshold';
        const params = new URLSearchParams(window.location.search);
        const returnToCheckout = params.get('return_to_checkout') === 'true';

        // For threshold blocks: swap — remove any existing threshold gift before adding
        // For target_collection (BXGY) blocks: additive — do not remove existing gifts
        const cartResp = await fetch('/cart.js');
        const cartJson = await cartResp.json();
        const existingThresholdGift = blockType === 'threshold'
            ? cartJson.items.find(item => item.properties._FreeGift && item.properties._FreeGiftThreshold)
            : null;

        const threshold = parseInt(this.getAttribute('threshold'));

        cart.dataset.giftAdded = 'true';
        if (existingThresholdGift || returnToCheckout) window.preventCartUpdate = true;

        const properties = {
            '_ItemPrice': 0,
            '_FreeGift': true,
            '_FreeGiftBlock': blockId,
            '_FreeGiftCartPrice': cartJson.total_price
        };
        if (threshold && threshold > 0) properties._FreeGiftThreshold = threshold;

        await addToCartGlobal(handle, variantId, 1, false, preorderMonth, properties);

        trackFSEvent('Free Gift Add', {
            threshold: threshold / 100,
            productType: this.getAttribute('product-type')
        });

        if (!returnToCheckout) window.preventCartUpdate = false;

        if (existingThresholdGift) {
            await new Promise(resolve => setTimeout(resolve, 500));

            if (existingThresholdGift.properties['_FreeGiftThreshold'] < threshold && existingThresholdGift.properties['_FreeGiftCartPrice'] < cartJson.total_price) {
                trackFSEvent('Free Gift Increase Threshold', {
                    oldThreshold: existingThresholdGift.properties['_FreeGiftThreshold'] / 100,
                    newThreshold: threshold / 100,
                    oldTotal: existingThresholdGift.properties['_FreeGiftCartPrice'] / 100,
                    newTotal: cartJson.total_price / 100
                });
            }

            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: existingThresholdGift.key,
                    quantity: 0
                })
            });
        }

        if (returnToCheckout) window.location.href = '/checkout';

        setTimeout(() => cart.dataset.giftAdded = 'false', 3000);
    }
}

customElements.define('free-gift-atc', FreeGiftAddToCart);


class ProductCard extends HTMLElement {
    connectedCallback() {
        this.handle = this.getAttribute('handle');

        const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) {
                observer.disconnect();
                this.load();
            }
        }, { rootMargin: '0px 0px 100% 0px' });

        observer.observe(this);
    }

    async load() {
        const resp = await fetch(`/products/${this.handle}?section_id=product-card`);
        const html = await resp.text();

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.card');

        const currentBackground = this.querySelector('.card__image')?.style.backgroundImage;
        if (currentBackground) card.querySelector('img').style.backgroundImage = currentBackground;

        if (this.querySelector('.card')) this.querySelector('.card').replaceWith(card);
        else this.replaceChildren(...card.children);
    }
}

customElements.define('product-card', ProductCard);


class CollectionDiscountTag extends HTMLElement {
    constructor() {
        super();

        const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) {
                observer.disconnect();
                this.init();
            }
        });

        observer.observe(this);
    }

    async init() {
        const handle = this.getAttribute('handle');
        const card = this.closest('.card');
        const hasSwatches = card && card.querySelector('card-swatch-selector');

        if (hasSwatches) {
            // Wait for the card-swatch elements to be available
            await new Promise(resolve => {
                const checkSwatches = () => {
                    const activeSwatch = card.querySelector('card-swatch[active]');
                    if (activeSwatch) {
                        resolve();
                    } else {
                        requestAnimationFrame(checkSwatches);
                    }
                };
                checkSwatches();
            });
            this.updateDiscountFromSwatch(card);
        } else {
            await this.updateDiscountFromCollection(handle);
        }
    }

    updateDiscountFromSwatch(card) {
        const activeSwatch = card.querySelector('card-swatch[active]');
        if (activeSwatch) {
            const discount = activeSwatch.getAttribute('discount-tag');
            if (discount > 0) {
                this.innerHTML = `Up to ${discount}% Off`;
                this.style.opacity = 1;
                this.classList.remove('hide');
            } else {
                this.innerHTML = '';
                this.classList.add('hide');
            }
        } else {
            this.classList.add('hide');
        }
    }

    async updateDiscountFromCollection(handle) {
        const resp = await fetch(`/collections/${handle}?section_id=collection-max-discount`);
        const html = await resp.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.shopify-section');
        const discount = parseInt(section.innerText);

        if (!isNaN(discount) && discount > 0) {
            this.innerHTML = `Up to ${discount}% Off`;
            this.style.opacity = 1;
            this.classList.remove('hide');
        } else {
            this.classList.add('hide');
        }
    }
}

customElements.define('collection-discount-tag', CollectionDiscountTag);


// Price test component
class PriceTest extends HTMLElement {
    connectedCallback() {
        this.checkTest();
        window.addEventListener('growthbookready', () => this.checkTest());
    }

    checkTest() {
        const tests = 'abc'.split('');
        const test = tests[parseInt(this.getAttribute('test'))];

        if (window.featureEnabled) {
            if (window.getActivePriceTest() == test) this.parentElement.innerHTML = this.innerHTML;
            this.setAttribute('loaded', '');
        }
    }
}

customElements.define('price-test', PriceTest);


// Product card shadow root
const themeStyles = document.querySelector('link[href*="/assets/theme.css"]')?.href;
const qatcStyles = document.querySelector('link[href*="/assets/quick-add-to-cart.css"]')?.href;

window.attachProductCard = (target, { title, image, url, qatc }) => {
    const urlObj = new URL(url);
    const handle = urlObj.pathname.split('/').pop();

    const shadow = target.attachShadow({ mode: 'open' });
    shadow.innerHTML = /* HTML */`
        <link rel="stylesheet" href="${themeStyles}">
        <link rel="stylesheet" href="${qatcStyles}">
        <div class="card ${theme.automaticDiscount ? 'automatic-discount': ''}">
            <img class="card__image" src="${image}" />
            <div class="card__details">
                <h3 class="card__heading">
                    <a href="${url}">${title}</a>
                </h3>
                <div class="card__price">
                    <dynamic-price data-handle="${handle}"></dynamic-price>
                </div>
            </div>
            ${handle.includes('build-your-own') || !qatc ? '' : /* HTML */ `
                <quick-add-to-cart is-button data-handle="${handle}">Add to Cart</quick-add-to-cart>
                <quick-add-to-cart data-handle="${handle}">Add to Cart</quick-add-to-cart>
            `}
        </div>
    `;
}

class ShopPromiseWrapper extends HTMLElement {
    constructor() {
        super();

        const checkPromiseElement = () => {
			const promiseElement = this.querySelector('delivery-promise-wc');
	
			if (promiseElement) {
				promiseElement.shadowRoot.firstElementChild.insertAdjacentHTML('beforebegin', /* HTML */ `
					<style>
						* {
							--color-background: transparent !important;
							--color-background-hover: transparent !important;
							--font-body-size: 14px !important;
							--content-row-gap: 4px !important;
						}

						.ShopPromiseLayoutInner__container {
							padding: 0 !important;
						}
					</style>
				`)
				return true;
			}
		}
	
		const promiseElementFound = checkPromiseElement();

		if (!promiseElementFound) {
			const observer = new MutationObserver(mutations => {
				if (checkPromiseElement()) observer.disconnect();
			});
	
			observer.observe(this, {childList: true, subtree: true});
		}
    }
}

customElements.define('shop-promise-wrapper', ShopPromiseWrapper);


// Fake scrollbar
class FakeScrollbar extends HTMLElement {
    constructor() {
        super();

        this.target = this.hasAttribute('target') ? this.parentElement.querySelector(this.getAttribute('target')) : this.parentElement;
        this.target.addEventListener('scroll', () => this.onScroll());
        this.margin = 0;

        const height = this.getAttribute('height') || '2px';

        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = /* HTML */ `
            <style>
                @keyframes fade-in {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }

                :host {
                    display: block;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    background: var(--color-border-border-primary, #E1E1E1);
                    z-index: 100;
                    height: ${height};
                    overflow: hidden;
                    animation: fade-in 500ms;
                }

                .bar {
                    height: 100%;
                    width: var(--width, 0%);
                    background: var(--color-bg-inverted-secondary, #434343);
                    border-radius: 50px;
                    transform: translateX(var(--left, 0));
                }
            </style>
            <div class="bar"></div>
        `;

        const observer = new IntersectionObserver(entries => {
            if (entries.some(e => e.isIntersecting)) {
                this.onScroll();
                observer.disconnect();
            }
        });

        observer.observe(this.target);
    }

    onScroll() {
        const width = this.target.clientWidth / (this.target.scrollWidth - this.margin * 2);
        this.style.setProperty('--width', `${(width * 100).toFixed(1)}%`);
        const left = ((this.target.scrollLeft - this.margin) / (this.target.scrollWidth - this.margin * 2) * 100) / width;
        this.style.setProperty('--left', `${left.toFixed(1)}%`);
    }

    static observedAttributes = ['margin'];

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'margin') {
            this.margin = parseInt(newValue);
            this.onScroll();
        }
    }
}

customElements.define('fake-scrollbar', FakeScrollbar);



/* Promo pill */

class PromoPill extends HTMLElement {
    constructor() {
        super();

        if (this.hasAttribute('code')) {
            const code = this.getAttribute('code');
            this.style.setProperty('--copied-text', `'Copied ${code} to clipboard!'`);
            console.log('has code attribute', code);

            this.addEventListener('click', () => {
                navigator.clipboard.writeText(code);
                this.classList.add('copied');
                setTimeout(() => this.classList.remove('copied'), 3500);
            });
        }
    }
}

customElements.define('promo-pill', PromoPill);


class AddToCart extends HTMLElement {
    constructor() {
        super();

        this.setAttribute('role', 'button');
        this.setAttribute('loaded', '');

        this.addEventListener('click', e => {
            if (e.target.hasAttribute('disabled')) return;
            this.addToCart();
        });
    }

    async addToCart() {
        const handle = this.getAttribute('handle');
        const variantId = this.getAttribute('variant-id');

        if (handle && variantId) {
            document.body.classList.add('adding-to-cart');
            this.classList.add('show-loading', 'show-loading--inverted');
            await addToCartGlobal(handle, variantId, 1, this.hasAttribute('bundle'), this.getAttribute('preorder'));
            this.classList.remove('show-loading', 'show-loading--inverted');

            this.setAttribute('added', '');
            setTimeout(() => this.removeAttribute('added'), 2000);

            this.dispatchEvent(new CustomEvent('addtocart', { bubbles: true }));
            document.body.classList.remove('adding-to-cart');

            await window.updateCartDrawer();
		    window.showCartDrawer((window.featureEnabled && window.featureEnabled('show-cart')) || Shopify.theme.name.includes('GWP') || window.innerWidth > 992);
        }
    }
}

customElements.define('add-to-cart', AddToCart);



class CountdownTimer extends HTMLElement {
    constructor() {
        super();

        this.end = Date.parse(this.getAttribute('end-time')) / 1000;
        this.interval = setInterval(() => this.update(), 1000);
        this.update();
    }

    update() {
        const now = Date.now() / 1000;
        const remaining = Math.max(0, this.end - now);

        const seconds = Math.floor(remaining % 60);
        const minutes = Math.floor((remaining / 60) % 60);
        const hours = Math.floor((remaining / (60 * 60)) % 24);
        const days = Math.floor(remaining / (60 * 60 * 24));

        this.querySelector('.countdown-timer__seconds .countdown-timer__count').innerText = seconds.toFixed();
        this.querySelector('.countdown-timer__minutes .countdown-timer__count').innerText = minutes.toFixed();
        this.querySelector('.countdown-timer__hours .countdown-timer__count').innerText = hours.toFixed();
        this.querySelector('.countdown-timer__days .countdown-timer__count').innerText = days.toFixed();

        if (remaining <= 0) {
            clearInterval(this.interval);
            this.remove();
        }
    }
}

customElements.define('countdown-timer', CountdownTimer);